/**
 * In-memory (never persisted) hand-off of the owner user object from a
 * just-completed login POST to the dashboard's first render, so the
 * dashboard doesn't need to immediately re-fetch /api/seat-map/auth/me and
 * race the just-issued session cookie (this used to produce a spurious 401
 * during the login->dashboard transition).
 *
 * Deliberately module-scoped, in-memory only (no sessionStorage/localStorage):
 * a hard page refresh always gets a fresh module instance, so a refresh (or
 * a direct URL load, or an expired session) correctly falls back to the
 * real /auth/me check instead of ever trusting stale data.
 *
 * Time-boxed rather than single-consumption: React.StrictMode's dev-only
 * double-effect-invocation means the consuming hook can legitimately read
 * this twice within the same navigation, a few ms apart - a short expiry
 * window handles that safely while still preventing indefinite stale reuse
 * on some later, unrelated navigation back to the dashboard.
 */
let pending = null; // { user, setAt }
const HANDOFF_WINDOW_MS = 5000;

export const setPendingOwnerUser = (user) => {
  pending = { user, setAt: Date.now() };
};

export const takePendingOwnerUser = () => {
  if (!pending) return null;
  const isFresh = Date.now() - pending.setAt < HANDOFF_WINDOW_MS;
  return isFresh ? pending.user : null;
};
